import { selectionControlSizes } from '../selectionControl/theme'
import { radioColors } from './consts'

const baseStyle = {
  control: {
    color: radioColors.unchecked,
    hoverColor: radioColors.hover,
    pressedColor: radioColors.pressed,
  },
}

const defaultProps = {
  size: 'md',
}

const parts = ['container', 'control', 'label']

// Sizes/gaps shared with Checkbox — see `selectionControl/theme.ts`. `lg` kept as a deprecated
// alias for `md` for backwards compatibility.
const sizes = selectionControlSizes

const variants = {}

export default {
  baseStyle,
  defaultProps,
  parts,
  sizes,
  variants,
}
